import React from 'react';

const HelpItem = (props) => {
  const { data } = props;

  return (
    <li className="js-item item ">
      <div className="item__desc">
        <h2 className="heading heading--2">
          { data.name }
          {' '}
        </h2>
        <p dangerouslySetInnerHTML={{ __html: data.description }} />
      </div>
    </li>
  );
};

export default HelpItem;
